module.exports = __webpack_public_path__ + "img/mycolour-dark.9263333e.png";